import React from 'react';
import { Card, CardHeader, CardBody, Table } from 'reactstrap';
import { Line } from 'react-chartjs-2';


const AdvertiserReport = () => {
  const advertiserReportData = [
    { id: 1, name: 'Advertiser 1', impressions: 1000, clicks: 500, conversions: 100 },
    { id: 2, name: 'Advertiser 2', impressions: 800, clicks: 400, conversions: 80 },
    { id: 3, name: 'Advertiser 3', impressions: 1200, clicks: 600, conversions: 150 },
    // Add more data as needed
  ];

  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Impressions',
        data: [1000, 1500, 1200, 1800, 2000, 1600],
        fill: false,
        borderColor: '#4c84ff',
      },
      {
        label: 'Clicks',
        data: [500, 600, 550, 700, 900, 800],
        fill: false,
        borderColor: '#51cbce',
      },
      {
        label: 'Conversions',
        data: [100, 120, 150, 110, 130, 140],
        fill: false,
        borderColor: '#f5365c',
      },
    ],
  };

  return (
    <div className="container-fluid py-4">
    <div className="row">
    <Card>
      <CardHeader>
        <h5>Advertiser Report</h5>
      </CardHeader>
      <CardBody>
        <div className="mb-4">
          <Line data={chartData} />
        </div>
        <Table responsive>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Impressions</th>
              <th>Clicks</th>
              <th>Conversions</th>
            </tr>
          </thead>
          <tbody>
            {advertiserReportData.map((report) => (
              <tr key={report.id}>
                <td>{report.id}</td>
                <td>{report.name}</td>
                <td>{report.impressions}</td>
                <td>{report.clicks}</td>
                <td>{report.conversions}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
    </div>
    </div>
  );
};

export default AdvertiserReport;
